const ddados = {
  Titulo: "Emitir Crachá",
  Campos: {
    InscricaoMunicipal: {
      Tipo: "number",
      Label: "Inscrição Municipal",
      Tooltip: "Inscrição Municipal",
      Placeholder: "Inscrição Municipal",
      Obrigatorio: true,
      Tamanho: 10
    },
    CpfCnpj: {
      Tipo: "mask",
      Mascara: "CPFCNPJ",
      Label: "CPF/CNPJ",
      Obrigatorio: true
    },
    Exercicio: {
      Tipo: "number",
      Label: "Exercício",
      Tooltip: "Exercício",
      Placeholder: "Exercício",
      Tamanho: 4,
      Obrigatorio: true
    }
  }
};

export { ddados };
